import styled from "styled-components";

export const TagsContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`

export const TagsTitle = styled.span`
  font-size: 1.25em;
  font-weight: 600;
  text-transform: none;
`

export const Tag = styled.div<{ color: string, darkText?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  //height: 32px;
  padding: 4px 16px;
  margin-right: 4px;
  border-radius: 4px;
  font-size: 1.25em;
  font-weight: 500;
  line-height: 1;
  background: ${({ color }) => color};
  color: ${({ darkText }) => darkText ? "#444" : "#fff"};
  user-select: none;
  cursor: default;
`
